module.exports = __webpack_public_path__ + "img/1.da460476.svg";